import React from 'react';
import { useSelector } from 'react-redux';

import { isConsentFlagActive } from '@wetransfer/transfer/component/consent-manager/flags';
import Icon from '@wetransfer/transfer/component/icon';
import LanguagePicker from '@wetransfer/transfer/component/languagepicker';
import { ABBEY } from '@wetransfer/transfer/constant/colors';
import { getPlanTier } from '@wetransfer/transfer/helper/user';
import Analytics from '@wetransfer/transfer/modules/analytics';
import I18n from '@wetransfer/transfer/modules/i18n';

export const Footer = () => {
  const { language, user } = useSelector((state) => ({
    language: state.session.language,
    user: state.user,
  }));

  const trackFooterLink = (name) => {
    Analytics.trackSnowplowEvent({
      category: 'navigation_bar_footer',
      action: name,
      label: getPlanTier(user) || 'anonymous',
    });
  };

  return (
    <footer className="footer">
      <div className="footer__menu">
        <Icon className="footer__logo" type="Logo" width={33} color={ABBEY} />
        <LanguagePicker />
        <nav className={`footer__nav footer__nav-${language}`}>
          <a
            title={I18n.t('panel.footer.terms')}
            href="/legal/terms"
            data-route-context="about"
            className="footer__link"
            onClick={() => trackFooterLink('clickFooterTerms')}
          >
            {I18n.t('panel.footer.terms')}
          </a>
          {isConsentFlagActive() && (
            <a
              title={I18n.t('transfer.consent-manager.button-cookies-privacy')}
              href="/legal/manage-cookies"
              data-route-context="cookie-manager"
              className="footer__link"
              onClick={() => trackFooterLink('clickFooterPrivacy')}
            >
              {I18n.t('transfer.consent-manager.button-cookies-privacy')}
            </a>
          )}

          <a
            title={I18n.t('panel.footer.press')}
            href={I18n.t('external_links.prco')}
            rel="external"
            className="footer__link"
            onClick={() => trackFooterLink('clickFooterPress')}
          >
            {I18n.t('panel.footer.press')}
          </a>
          <a
            title={I18n.t('panel.footer.jobs')}
            href={I18n.t('external_links.homerun')}
            rel="external"
            className="footer__link"
            onClick={() => trackFooterLink('clickFooterJobs')}
          >
            {I18n.t('panel.footer.jobs')}
          </a>
        </nav>
      </div>
      <div className={`footer__social-links footer__social-links-${language}`}>
        <a
          title={I18n.t('panel.footer.twitter')}
          href={I18n.t('external_links.twitter')}
          rel="external"
          className="footer__social-link"
        >
          <Icon type="Twitter" width={20} />
        </a>
        <a
          title={I18n.t('panel.footer.facebook')}
          href={I18n.t('external_links.facebook')}
          rel="external"
          className="footer__social-link"
        >
          <Icon type="Facebook" width={20} />
        </a>
        <a
          title={I18n.t('panel.footer.instagram')}
          href={I18n.t('external_links.instagram')}
          rel="external"
          className="footer__social-link"
        >
          <Icon type="Instagram" width={20} />
        </a>
        <a
          title={I18n.t('panel.footer.youtube')}
          href={I18n.t('external_links.youtube')}
          rel="external"
          className="footer__social-link"
        >
          <Icon type="Youtube" width={20} />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
